<template>
  <div>          
    <div class="panel panel-primary">
        <div class="panel-heading">Registrar un usuario nuevo</div>
        <div class="panel-body">                                              
            <div class="input-group form-group">
              <span class="input-group-addon"><span class='glyphicon glyphicon-italic glyphicon-tamano'></span></span>
						  <input type="text" tabindex="2" class="form-control" placeholder="Nombre"  v-model='newUser.name'>
						</div>
            <div class="input-group form-group">
              <span class="input-group-addon"><span class='glyphicon glyphicon-user glyphicon-tamano'></span></span>
						  <input type="text" tabindex="2" class="form-control" placeholder="Usuario"  v-model='newUser.username'>
						</div>
            <div class="input-group form-group">
              <span class="input-group-addon"><span class='glyphicon glyphicon-lock glyphicon-tamano'></span></span>
						  <input type="password" tabindex="2" class="form-control" placeholder="Clave"  v-model='newUser.password'>
						</div>
            <div class="input-group form-group">
              <span class="input-group-addon"><span class='glyphicon glyphicon-lock glyphicon-tamano'></span></span>
						  <input type="password" tabindex="2" class="form-control" placeholder="Confirmar clave"  v-model='newUser.password2'>
						</div>
            <div class="input-group form-group">
              <span class="input-group-addon"><span style="font-weight: bold;font-size:1.3em;" class='glyphicon-tamano'>@</span></span>
						  <input type="text" tabindex="2" class="form-control" placeholder="Email"  v-model='newUser.email'>
						</div>   
            <span class='homeform'>                    
              <button class="btn btn-primary btn-block" @click='validateFields' >Crear Usuario</button>
            </span>
        </div>
    </div>             
  </div>
</template>

<script>
import { eventBus } from '../../main';
export default {  
  data: function () {     
    return {
      newUser:{
        name:'',
        username:'',
        password:'',
        password2:'',
        email:'',
      }       
    }
  },
  mounted: function () {        
       
  },
  methods: {
     validateFields: function(){
      
      eventBus.$emit('hide');

      if(this.newUser.name.length == 0){        
        eventBus.$emit('genericMessage', false, "Favor llenar 'Nombre'");
        return;
      }

      if(this.newUser.username.length == 0){        
        eventBus.$emit('genericMessage', false, "Favor llenar 'Usuario'");
        return;
      }

      if(this.newUser.password.length == 0){        
        eventBus.$emit('genericMessage', false, "Favor llenar 'Clave'");
        return;
      }

      if(this.newUser.password2.length == 0){        
        eventBus.$emit('genericMessage', false, "Favor llenar 'Confirmar clave'");
        return;
      }

      if(this.newUser.email.length == 0){        
        eventBus.$emit('genericMessage', false, "Favor llenar 'Email'");
        return;
      }

      if(this.newUser.password != this.newUser.password2){        
        eventBus.$emit('genericMessage', false, "Claves no son iguales");
        return;
      }

      this.$http.post('api/register', this.newUser ).then(response => {                                                            
        if(response.body.status == 1){
          eventBus.$emit('genericMessage', true , response.body.msg);            

        }
        else
          eventBus.$emit('genericMessage', false , response.body.msg);
          this.$router.push('/');	        
          this.$router.go('');	        
      }, response => {                        
            eventBus.$emit('errorMsg', response);          
      });

    },
  },
  filters: {
     
  },
  computed: {
    
  }
}
</script>

<style scoped>


  @media screen and (min-width: 0px) {  
      
   }

  @media screen and (max-width: 981px) {  
      .container {  
        font-size: 4em;            
      }       

      .glyphicon-tamano {
        font-size: 3em !important;
      }

      input {        
        position:relative;
        width:100%;
        height:100px;
        font-size: 0.8em;            
      }

      button {        
        position:relative;
        width:100%;
        height:100px;
        font-size: 0.8em;            
      }
   }

  @media screen and (min-width: 981px) {          
      .container {        
        font-size: 1.4em;    
        width: 400px;
      }      

      button {               
        font-size: 1.2em;            
      }

      input {               
        font-size: 1em;            
      }      
   }

</style>



// WEBPACK FOOTER //
// Register.vue?051126ca